import { createAction } from 'redux-actions';

import { GET_ACTIONS } from './constants';

export const getActions = createAction(GET_ACTIONS.REQUEST);
